import { createApiClient } from './apiClient';
import { API_BASE_URL } from '../config';
import {
  TransferFundsRequest,
  TransferFundsResponse,
  validateTransferFundsRequest,
} from './fundTransferContracts';

const fundTransferApi = createApiClient({
  baseURL: API_BASE_URL,
  withCredentials: true,
});

export async function transferFunds(
  token: string | null,
  payload: TransferFundsRequest
): Promise<TransferFundsResponse> {
  const validation = validateTransferFundsRequest(payload);
  if (!validation.success) {
    return { success: false, message: validation.message };
  }

  const headers: Record<string, string> = {};
  if (token) headers.Authorization = `Bearer ${token}`;

  const resp = await fundTransferApi.post<TransferFundsResponse>(
    '/transfer-funds',
    validation.data,
    { headers }
  );

  return resp.data;
}
